'use client';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Locale } from './i18n';

interface AppStore {
  theme: 'dark' | 'light';
  locale: Locale;
  toggleTheme: () => void;
  setLocale: (locale: Locale) => void;
}

// Backend integration point: Persist theme/locale preference to user profile via PATCH /api/user/preferences
export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      theme: 'dark',
      locale: 'ar',
      toggleTheme: () =>
        set((state) => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'dayflow-prefs',
      // Prevent hydration mismatch: don't rehydrate during SSR
      skipHydration: true,
    }
  )
);